export default class ts {
  constructor(t) {
    (this.xc = t), (this.xc = t);
  }
  zc(t) {
    return null == this.xc || this.xc === t[0];
  }
  static fromJson(t) {
    return new ts(t ? t.event_name : null);
  }
  bt() {
    return this.xc;
  }
}
